module.exports = __webpack_public_path__ + "img/vert-7.913771a1.png";